import { useState, useCallback, useEffect } from "react";
import DataTable from '../DataTable/DataTable';
import { NotificationManager } from "react-notifications";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import hiringReports from "../../apis/hiringReport/hiringReport";
import { convertDate } from "../AcitivityModal/assistingFunctions";
import { codeTofield } from "../GlobalAssistingFunctions/GlobalAssistingFunctions";
import config from "../../Config.json";
import "./requisitionReports.css";
const stylesSX = {
    odd: {
        background: '#F6F6F6 !important',
    },
    even: {
        background: '#ffffff !important',
    },
    backdrop: (theme) => ({
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    }),
    waitingText: {
        marginLeft: '5px',
    },
};


const HiringReport = (props) => {
    const {
        userType,
        userIdType,
        userRecruitmentpartnerId,
        startSelectedDate,
        endSelectedDate,
        filter,
        exports,
        setTriggerHiring
    } = props;

    const [takeNumberOfResult, setTakeNumberOfResult] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [dataResult, setDataResult] = useState([]);
    const [totalResult, setTotalResult] = useState(0);
    const [isSearching, setIsSearching] = useState(true);
    const [isExporting, setIsExporting] = useState(false);
    const [prevStartDate, setPrevStartDate] = useState(null);
    const [prevEndDate, setPrevEndDate] = useState(null);
    const [prevFilter, setPrevFilter] = useState({});
    // Define columns for the DataTable
    const columns = [
        {
            accessorKey: "reqreferenceId",
            header: "Job Id (Internal)",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "placementType",
            header: "Placement Type",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "billRate",
            header: "Quoted Bill Rate",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
            cell: ({ getValue }) => getValue() || 0,
        },
        {
            accessorKey: "fee",
            header: "Fee",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "endDate",
            header: "Est End Date",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
            cell: ({ getValue }) => {
                const value = getValue();
                return value ? new Date(value).toLocaleDateString() : "";
            },
        },
        {
            accessorKey: "priority",
            header: "Job Priority",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "clientJobId",
            header: "Optional Job Ref-Job Id",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "divisionName",
            header: "Job Division",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "divisionName",
            header: "Department",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "spocName",
            header: "Hiring Manager Name",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "spocEmail",
            header: "Hiring Manager Email",
            width: "300px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "currentStatus",
            header: "Current Status",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
            cell: ({ getValue }) => codeTofield(getValue()),
        },
        {
            accessorKey: "startDate",
            header: "Primary Sales - Start Record",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
            cell: ({ getValue }) => {
                const value = getValue();
                return value ? new Date(value).toLocaleDateString() : "";
            },
        },
        {
            accessorKey: "startDate_DisplayDate",
            header: "Status Updated On",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
            cell: ({ getValue }) => {
                const value = getValue();
                return value ? new Date(value).toLocaleDateString() : "";
            },
        },
        {
            accessorKey: "hourlyMarginSubmission",
            header: "Hourly Margin Submission",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "hourlyPayRateSubmission",
            header: "Hourly Margin Percentage Submission",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "hourlyMarginSelected",
            header: "Hourly Margin Selected",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "hourlyPayRateSelected",
            header: "Hourly Margin Percentage Selected",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "hourlyMarginStarted",
            header: "Hourly Margin Started",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "hourlyPayRateStarted",
            header: "Hourly Margin Percentage Started",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "candEmail",
            header: "Cand Email",
            width: "300px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "candName",
            header: "Cand Name",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "primarySkill",
            header: "Primary Skill",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "clientName",
            header: "Client Name",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        // {
        //     accessorKey: "clientJobId",
        //     header: "Client ID",
        //     width: "180px",
        //     enableSorting: true,
        //     enableFiltering: false,
        // },
        {
            accessorKey: "candSource",
            header: "Source",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorFn: (row) => row.salarySubmission || row.hourlyPayRateSubmission,
            id: "agreedBillRate", // must give an id since accessorFn is used
            header: "Agreed Bill Rate",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorFn: (row) => row.salaryStarted || row.hourlyPayRateStarted,
            id: "finalSalary", // must give an id since accessorFn is used
            header: "Final Salary",
            size: 180, // instead of width in v8
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "recruitmentLeader",
            header: "Primary Sales - Recruitment Leader",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "currentRL",
            header: "Current - Recruitment Leader",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "teamLeader",
            header: "TL Name",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "recruiter",
            header: "Primary Recruiter",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: "referredBy",
            header: "Referrer",
            width: "180px",
            enableSorting: true,
            enableFiltering: false,
        },
    ];

    // Search function without debounce
    const performSearch = useCallback(async (
        userRecruitmentpartnerId,
        pageNumber,
        takeNumberOfResult,
        startSelectedDate,
        endSelectedDate,
        userId,
        filter
    ) => {
        try {
            setIsSearching(true);
            const filters = {
                placementType: filter?.placementType || [],
                clientName: filter?.clientName || [],
                divisionId: filter?.divisionId || [],
                clientJobId: filter?.clientJobId || "",
                teamId: filter?.teamId || []
            };
            const payload = {
                orgId: userRecruitmentpartnerId,
                page: pageNumber,
                size: takeNumberOfResult,
                formattedDatestart: convertDate(startSelectedDate),
                formattedDateend: convertDate(endSelectedDate),
                isExport: false,
                userId: userId,
                role: userType,
                additionalFilter: filters
            };
            const res = await hiringReports(payload);

            if (res?.totalCount?.[0]?.total > 0) {
                const data = res.data.map(d => ({ ...d, billRate: d?.billRate?.maximum }));
                setDataResult(data);
                setTotalResult(res.totalCount[0].total);
            } else {
                setDataResult([]);
                setTotalResult(0);
            }
            setIsSearching(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            NotificationManager.error("Failed to fetch data", "Error", 10000);
            setDataResult([]);
            setTotalResult(0);
            setIsSearching(false);
        }
    }, [userType]);

    // Handle page change
    const handlePageChange = (newPage, newPageSize) => {
        setPageNumber(newPage);
        if (newPageSize && newPageSize !== takeNumberOfResult) {
            setTakeNumberOfResult(newPageSize);
        }
    };

    // Handle page size change
    const handlePageSizeChange = (newPageSize) => {
        setTakeNumberOfResult(newPageSize);
        setPageNumber(1);
    };



    useEffect(() => {
        const datesChanged = prevStartDate !== startSelectedDate || prevEndDate !== endSelectedDate;
        const filtersChanged = JSON.stringify(prevFilter) !== JSON.stringify(filter);

        if (datesChanged || filtersChanged) {
            setPageNumber(1);
            setPrevStartDate(startSelectedDate);
            setPrevEndDate(endSelectedDate);
            setPrevFilter({ ...filter });
        }
    }, [startSelectedDate, endSelectedDate, filter, prevStartDate, prevEndDate, prevFilter]);

    useEffect(() => {
        const start = convertDate(startSelectedDate);
        const end = convertDate(endSelectedDate);
        if (start && end && start <= end) {
            // When any dependency changes, schedule a search.
            setIsSearching(true);
            setDataResult([]);

            const timeoutId = setTimeout(() => {
                performSearch(
                    userRecruitmentpartnerId,
                    pageNumber,
                    takeNumberOfResult,
                    startSelectedDate,
                    endSelectedDate,
                    userIdType,
                    filter
                );
            }, 1000); // 1000ms debounce delay

            // Cleanup cancels the pending search if dependencies change quickly.
            return () => clearTimeout(timeoutId);
        } else {
            NotificationManager.error("Please select a valid date range", "Error", 10000);
            setDataResult([]);
            setTotalResult(0);
        }
    }, [pageNumber, takeNumberOfResult, startSelectedDate, endSelectedDate, filter, userRecruitmentpartnerId, userIdType, performSearch]);

    const exportToExcel = useCallback(async () => {
        setIsExporting(true);
        setTriggerHiring(false);
        const maxSize = config.MAX_SIZE  // API pagination size
        const end = Math.ceil(totalResult / maxSize);
        let pageStart = 1;
        const exportArr = [];

        try {
            for (let start = 0; start < end; start++) {
                const payload = {
                    orgId: userRecruitmentpartnerId,
                    isExport: true,
                    page: pageStart,
                    size: maxSize,
                    formattedDatestart: convertDate(startSelectedDate),
                    formattedDateend: convertDate(endSelectedDate),
                    userId: userIdType,
                    role: userType,
                    additionalFilter: {
                        placementType: filter?.placementType || [],
                        clientName: filter?.clientName || [],
                        divisionId: filter?.divisionId || [],
                        clientJobId: filter?.setAdditionalFilter || "",
                        teamId: filter?.teamId || []
                    }
                };

                const res = await hiringReports(payload);
                if (res?.totalCount?.[0]?.total > 0) {
                    res.data.forEach((element) => {
                        let data = {
                            "Job Id (Internal)": element?.reqreferenceId,
                            "Placement Type": element?.placementType,
                            "Quoted Bill Rate": element?.billRate?.maximum,
                            "Fee": element?.fee,
                            "Est End Date": element?.endDate ? new Date(element?.endDate).toLocaleDateString() : "",
                            "Job Priority": element?.priority,
                            "Optional Job Ref-Job Id": element?.clientJobId,
                            "Job Division": element?.divisionName,
                            "Department": element?.divisionName,
                            "Hiring Manager Name": element?.spocName,
                            "Hiring Manager Email": element?.spocEmail,
                            "Current Status": codeTofield(element?.currentStatus),
                            "Primary Sales - Start Record": element?.startDate ? new Date(element?.startDate).toLocaleDateString() : "",
                            "Status Updated On": element?.startDate_DisplayDate ? new Date(element?.startDate_DisplayDate).toLocaleDateString() : "",
                            "Hourly Margin Submission": element?.hourlyMarginSubmission,
                            "Hourly Margin Selected": element?.hourlyMarginSelected,
                            "Hourly Margin Started": element?.hourlyMarginStarted,
                            "Hourly Margin Percentage Submission": element?.hourlyPayRateSubmission,
                            "Hourly Margin Percentage Selected": element?.hourlyPayRateSelected,
                            "Hourly Margin Percentage Started": element?.hourlyPayRateStarted,
                            "Cand Email": element?.candEmail,
                            "Cand Name": element?.candName,
                            "Primary Skill": element?.primarySkill,
                            "Client Name": element?.clientName,
                            // "Client ID": element?.clientJobId,
                            "Source": element?.candSource,
                            "Agreed Bill Rate": element?.salarySubmission || element?.hourlyPayRateSubmission,
                            "Final Salary": element?.salaryStarted || element?.hourlyPayRateStarted,
                            "Primary Sales - Recruitment Leader": element?.recruitmentLeader,
                            "Current - Recruitment Leader": element?.currentRL,
                            "TL Name": element?.teamLeader,
                            "Primary Recruiter": element?.recruiter,
                            "Referrer": element?.referredBy
                        };
                        exportArr.push(data);
                    });
                }

                pageStart = pageStart + maxSize;
            }

            if (exportArr.length === 0) {
                NotificationManager.error("No data present", "Error", 10000);
                setIsExporting(false);
            } else {
               
               
                // Lazy load XLSX only when needed for export
                const { utils, writeFile } = await import("xlsx");
                const wb = utils.book_new();
                const ws = utils.json_to_sheet(exportArr);
                utils.book_append_sheet(wb, ws, "HiringReport");

                writeFile(wb, `HiringReport.xlsx`, { bookType: "xlsx", type: "file" });
            }

        } catch (error) {
            console.error("Error exporting:", error);
            NotificationManager.error("Failed to export", "Error", 10000);
        } finally {
            setIsExporting(false);
        }
    }, [totalResult, userRecruitmentpartnerId, startSelectedDate, endSelectedDate, userIdType, userType, filter, setTriggerHiring]);

    useEffect(() => {
        if (exports) {
            exportToExcel();
        }
    }, [exports, exportToExcel]);

    return (
        <>
            <Backdrop sx={stylesSX.backdrop} open={isExporting}>
                <CircularProgress color="inherit" />
                <Typography sx={stylesSX.waitingText}>Please wait...</Typography>
            </Backdrop>

            <DataTable
                data={dataResult}
                columns={columns}
                isLoading={isSearching}
                totalRecords={totalResult}
                currentPage={pageNumber}
                pageSize={takeNumberOfResult}
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}

                enableFiltering={false}
                enablePagination={true}
                enableSorting={false}
                pageSizeOptions={[10, 20, 50, 100]}
                isServerSide={true}
                className="kendo_reports"
                noDataText="No results found !"
            />
        </>
    );
};

export default HiringReport;
